<template>
  <div
    class="bg-color-main rounded-full flex justify-center items-center"
    :class="[bgSize ? bgSize : 'w-18 h-18']"
  >
    <img
      src="@images/BS.png"
      alt=""
      onerror="this.style.display='none';"
      :class="[imgSize ? imgSize : 'w-10 h-10']"
    />
  </div>
</template>
<script setup>
const props = defineProps({
  bgSize: {
    type: String,
    default: ""
  },
  imgSize: {
    type: String,
    default: ""
  }
});
</script>
<style scoped></style>
